import { render, staticRenderFns } from "./ticTacToe.vue?vue&type=template&id=a48947ec&"
import script from "./ticTacToe.vue?vue&type=script&lang=js&"
export * from "./ticTacToe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports